import {
  Box,
  FormControl,
  Grid,
  CardContent,
  Card,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material"
import { useState, useEffect } from "react"
import { Trans, useTranslation } from "react-i18next"
import { initialState } from "./InitialStates/AutorisationContracterInitialState"
import axios from "axios"
import Turnstile, { useTurnstile } from "react-turnstile"
import "./CSS/colorMessages.css"
import appendObjectToFormData from '../utils/useFormData'
import { useNavigate } from "react-router-dom"

const FormulaireAutorisationContracter = () => {
  let navigate = useNavigate()
  const [autorisation, setAutorisation] = useState(initialState)
  const [reCaptchaRequest, setReCaptcha] = useState({ reCaptchaToken: "", remoteip: null })
  const [errorPrenom, setErrorPrenom] = useState("")
  const [errorNom, setErrorNom] = useState("")
  const [errorNomLegal, setErrorNomLegal] = useState("")
  const [errorCourriel, setErrorCourriel] = useState("")
  const [errorTelephone, setErrorTelephone] = useState("")
  const [errorSujet, setErrorSujet] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [errorSubmission, setErrorSubmission] = useState("")
  const [successForm, setSuccessForm] = useState("")
  const { t } = useTranslation()
  const [saved, setSaved] = useState(false)
  const [loading, setLoading] = useState(false)
  
  const decodeHtmlEntities = (text: string | null = ''): string => {
    return text 
      ? text
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
      : '';
  };
  const goToConfirmation = () => {
    return navigate("/confirmation")
  }

  useEffect(() => {
    document.title = "Autorisation de contracter"
  }, [])

  const handleOnChange = (event: any) => {
    const { name, value } = event.target
    setAutorisation((prevState) => {
      return {
        ...prevState,
        [name]: value,
      }
    })
  }


  const TurnstileWidget = () => {
    const turnstile = useTurnstile()
    return (
      <Turnstile
        sitekey="0x4AAAAAAATUkYKisAyqVMcx"
        onVerify={async (token) => {
          const res = await axios.get("https://api.ipify.org/?format=json")
          setReCaptcha({ reCaptchaToken: token, remoteip: res.data.ip })
        }}
      />
    )
  }

  useEffect(() => {
    handleErrors()
  }, [autorisation])

  const handleErrors = () => {
    if (errorPrenom === t("messagesUtilisateurs.lblChampRequis") && autorisation.prenom !== "") {
      setErrorPrenom("")
    }
    if (errorNom === t("messagesUtilisateurs.lblChampRequis") && autorisation.nom !== "") {
      setErrorNom("")
    }
    if (errorNomLegal === t("messagesUtilisateurs.lblChampRequis") && autorisation.nomLegalEntrepriseNumeroClient !== "") {
      setErrorNomLegal("")
    }
    if (errorCourriel === t("messagesUtilisateurs.lblChampRequis") && autorisation.courriel !== "") {
      setErrorCourriel("")
    }
    if (errorSujet === t("messagesUtilisateurs.lblChampRequis") && autorisation.sujet !== "") {
      setErrorSujet("")
    }
    if (errorMessage === t("messagesUtilisateurs.lblChampRequis") && autorisation.message !== "") {
      setErrorMessage("")
    }
  }

  const handleFormatErrors = (fieldName: string) => {
    var regexCourriel =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    var regexTelephone =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    if (fieldName === "courriel") {
      if (
        autorisation.courriel !== "" &&
        !regexCourriel.test(autorisation.courriel)
      ) {
        setErrorCourriel(t("messagesUtilisateurs.communicationRenseignement.lblFormatCourrielInvalide"))
      } else setErrorCourriel("")
    }
    else if (fieldName === "telephone") {
      if (
        autorisation.telephone !== "" &&
        !regexTelephone.test(autorisation.telephone)
      ) {
        setErrorTelephone(t("messagesUtilisateurs.communicationRenseignement.lblFormatNumeroTelephone"))
      } else setErrorTelephone("")
    }
  }

  const handleSubmit = () => {
    let error = false
    if (autorisation.prenom === "") {
      setErrorPrenom(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorPrenom("")
    if (autorisation.nom === "") {
      setErrorNom(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorNom("")
    if (autorisation.nomLegalEntrepriseNumeroClient === "") {
      setErrorNomLegal(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorNomLegal("")
    var regexCourriel =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    var regexTelephone =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    if (autorisation.courriel === "") {
      setErrorCourriel(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else if (!regexCourriel.test(autorisation.courriel)) {
      setErrorCourriel(t("messagesUtilisateurs.communicationRenseignement.lblFormatCourrielInvalide"))
      error = true
    } else setErrorCourriel("")
    if (
      autorisation.telephone !== "" &&
      !regexTelephone.test(autorisation.telephone)
    ) {
      setErrorTelephone(t("messagesUtilisateurs.communicationRenseignement.lblFormatNumeroTelephone"))
      error = true
    } else setErrorTelephone("")
    if (autorisation.sujet === "") {
      setErrorSujet(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorSujet("")
    if (autorisation.message === "") {
      setErrorMessage(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorMessage("")
    if (error) setErrorSubmission(t("messagesUtilisateurs.lblErreurChampsFormulaire"))
    if (!error) {

      const formData = new FormData()

      appendObjectToFormData(formData, 'autorisationForm', autorisation)
      appendObjectToFormData(formData, 'reCaptchaRequest', reCaptchaRequest)
      formData.append('nomFormulaire', 'AutorisationContracter')
      formData.append('nomEntrepriseOuIndividu', autorisation.nomLegalEntrepriseNumeroClient)
      formData.append('adresseCourriel', autorisation.courriel)

      setLoading(true)
      setSaved(true)
      axios
        .post(
          process.env.REACT_APP_API_URL + "/v1/TraiterFormulaires/upload",
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          }
        )
        .then((response) => {
          setSaved(true)
          setSuccessForm(t("messagesUtilisateurs.lblSuccesSoumission"))
          setErrorSubmission("")
          goToConfirmation()
        })
        .catch((error) => {
          setSaved(false)
          setSuccessForm("")
          setErrorSubmission(
            t("messagesUtilisateurs.lblErreurEnvoiFormulaire")
          )
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          })
        })
    }
    else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  }

  return (
    <>
      <Card className="card" sx={{ minWidth: 275 }}>
        <CardContent>
          <Box component="form" sx={{ "& > :not(style)": { m: 1 } }}>
            {successForm && (
              <strong id="success" role="alert" className="success">
                <Trans>{successForm}</Trans>
              </strong>
            )}

            {errorSubmission && (
              <strong id="error-submission" role="alert" className="error">
                <Trans>{errorSubmission}</Trans>
              </strong>
            )}

            <h1>
              <Trans>{t("formulairesRenseignementsGenerauxEtAutorisationContracter.lblPageAutorisationContracter")}</Trans>
            </h1>
            <Grid container>
              <Grid item xs={6}>
                <FormControl className="form-cell width-98">
                  <TextField required
                    label={<Trans>{t("formulaireContact.lblChampPrenom")}</Trans>}
                    name="prenom"
                    value={decodeHtmlEntities(autorisation.prenom || '')}
                    onChange={handleOnChange}
                    fullWidth
                    aria-describedby="error-prenom"
                    style={{ backgroundColor: errorPrenom ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                  />
                  <div>
                    {errorPrenom && (
                      <strong id="error-prenom" role="alert" className="error">
                        <Trans>{errorPrenom}</Trans>
                      </strong>
                    )}
                  </div>
                </FormControl>

              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField required
                    label={<Trans>{t("formulaireContact.lblChampNom")}</Trans>}
                    name="nom"
                    value={decodeHtmlEntities(autorisation.nom || '')}
                    onChange={handleOnChange}

                    fullWidth
                    aria-describedby="error-nom"
                    style={{ backgroundColor: errorNom ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                  />
                </FormControl>
                <div>
                  {errorNom && (
                    <strong id="error-nom" role="alert" className="error">
                      <Trans>{errorNom}</Trans>
                    </strong>
                  )}
                </div>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={6}>
                <FormControl className="width-98">
                  <TextField required
                    label={
                      <Trans>
                        {t("formulairesRenseignementsGenerauxEtAutorisationContracter.lblChampNomLegal")}
                      </Trans>
                    }
                    name="nomLegalEntrepriseNumeroClient"
                    value={decodeHtmlEntities(autorisation.nomLegalEntrepriseNumeroClient || '')}
                    onChange={handleOnChange}

                    fullWidth
                    aria-describedby="error-nom-legal"
                    style={{ backgroundColor: errorNomLegal ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                  />
                </FormControl>
                <div>
                  {errorNomLegal && (
                    <strong
                      id="error-nom-legal"
                      role="alert"
                      className="error"
                    >
                      <Trans>{errorNomLegal}</Trans>
                    </strong>
                  )}
                </div>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField required
                    label={<Trans>{t("formulaireContact.lblChampCourriel")}</Trans>}
                    name="courriel"
                    value={decodeHtmlEntities(autorisation.courriel || '')}
                    onChange={handleOnChange}
                    onBlur={() => handleFormatErrors("courriel")}

                    fullWidth
                    aria-describedby="error-courriel"
                    style={{ backgroundColor: errorCourriel ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                  />
                </FormControl>
                <div>
                  {errorCourriel && (
                    <strong
                      id="error-courriel"
                      role="alert"
                      className="error"
                    >
                      <Trans>{errorCourriel}</Trans>
                    </strong>
                  )}
                </div>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={6}>
                <FormControl className="width-98">
                  <TextField
                    label={<Trans>{t("formulaireContact.lblChampTelephone")}</Trans>}
                    name="telephone"
                    value={decodeHtmlEntities(autorisation.telephone || '')}
                    onChange={handleOnChange}
                    onBlur={() => handleFormatErrors("telephone")}
                    aria-describedby="error-telephone"
                    style={{ backgroundColor: errorTelephone ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                  />
                </FormControl>
                <div>
                  {errorTelephone && (
                    <strong id="error-telephone" role="alert" className="error" >
                      <Trans>{errorTelephone}</Trans>
                    </strong>
                  )}
                </div>
              </Grid>
            </Grid>
            <FormControl fullWidth>
              <TextField required
                label={<Trans>{t("formulairesRenseignementsGenerauxEtAutorisationContracter.lblChampSujet")}</Trans>}
                name="sujet"
                value={decodeHtmlEntities(autorisation.sujet || '')}
                onChange={handleOnChange}
                aria-describedby="error-sujet"
                style={{ backgroundColor: errorSujet ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
              />
            </FormControl>
            {errorSujet && (
              <strong id="error-sujet" role="alert" className="error">
                <Trans>{errorSujet}</Trans>
              </strong>
            )}

            <FormControl fullWidth>
              <TextField required
                name="message"
                label={<Trans>{t("formulairesRenseignementsGenerauxEtAutorisationContracter.lblChampMessage")}</Trans>}

                multiline
                rows={8}
                onChange={handleOnChange}
                value={decodeHtmlEntities(autorisation.message || '')}
                aria-describedby="error-message"
                style={{ backgroundColor: errorMessage ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
              />
            </FormControl>
            {errorMessage && (
              <strong id="error-message" role="alert" className="error">
                <Trans>{errorMessage}</Trans>
              </strong>
            )}

            {TurnstileWidget()}

            <div>
              <FormControl>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={saved}
                >
                  <Trans>{t("formulairesRenseignementsGenerauxEtAutorisationContracter.ctaSoumettre")}</Trans>
                  {loading && (<CircularProgress />)}
                </Button>
              </FormControl>
            </div>
          </Box>
        </CardContent>
      </Card>
    </>
  )
}

export default FormulaireAutorisationContracter